<div class="login-container" [ngClass]="{'dark-mode': isDarkMode}">
  <div class="theme-toggle">
    <button mat-icon-button (click)="toggleTheme()" matTooltip="Cambiar tema">
      <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
  </div>

  <div class="login-card-container">
    <mat-card class="login-card">
      <mat-card-header>
        <mat-card-title>Iniciar Sesión</mat-card-title>
        <mat-card-subtitle>Ingresa tus credenciales para continuar</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-field">
            <mat-form-field appearance="outline">
              <mat-label>Correo electrónico</mat-label>
              <input matInput formControlName="email" placeholder="ejemplo@correo.com" type="email">
              <mat-icon matPrefix>email</mat-icon>
              <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
                El correo electrónico es obligatorio
              </mat-error>
              <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
                Ingresa un correo electrónico válido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-form-field appearance="outline">
              <mat-label>Contraseña</mat-label>
              <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'">
              <mat-icon matPrefix>lock</mat-icon>
              <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
                La contraseña es obligatoria
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-options">
            <mat-checkbox formControlName="rememberMe" color="primary">Recuérdame</mat-checkbox>
            <a routerLink="/forgot-password" class="forgot-password">¿Olvidaste tu contraseña?</a>
          </div>

          <div class="login-error" *ngIf="loginError">
            <mat-error>{{ loginError }}</mat-error>
          </div>

          <button
            mat-raised-button
            color="primary"
            type="submit"
            class="login-button"
            [disabled]="loginForm.invalid || isLoading">
            <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
            <span *ngIf="!isLoading">Iniciar Sesión</span>
          </button>

          <div class="separator">
            <span class="separator-text">o continúa con</span>
          </div>

          <div class="social-buttons">
            <button mat-stroked-button type="button" class="google-button">
              <mat-icon>public</mat-icon> Google
            </button>
            <button mat-stroked-button type="button" class="facebook-button">
              <mat-icon>facebook</mat-icon> Facebook
            </button>
          </div>

          <div class="register-link">
            ¿No tienes cuenta? <a routerLink="/register">Crea una</a>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
